import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Space } from 'antd';
import { updateConfig } from '@store/serviceIntegrations/integrationForm/actions';
import { CURRENT_PRODUCT_MODE , SERVICE_INTEGRATION_MODE_FORM } from '@utils/constants';
import {
  setWarningModalVisibility,
  updateTableAction,
} from '@store/serviceIntegrations/existingIntegrations/actions';
import { setMode, setEnablePartnerModalVisibility } from '@store/serviceIntegrations/base/actions';
import { getItems } from './utils';
// TODO: add the partners module in top level
import { getIntegrationPartners } from '../../available-integrations/partners';
import { MoreOutlined } from '@ant-design/icons';

const configStateCode = {
  delete: 0,
  disable: 1,
  enable: 2,
};

function KebabColumn({ rowData }: any) {
  const { configId } = rowData;
  const dispatch = useDispatch();

  const partnerList = getIntegrationPartners(CURRENT_PRODUCT_MODE);
  const featureFlag = useSelector(partnerList[rowData.partnerName]?.featureFlag) ?? false;

  const onApply = ({ key: selectedMenuItem }) => {
    // for edit, fetch the whole details and show the form view
    // for status change, send action to show the modal

    if (featureFlag) {
      if (selectedMenuItem === 'edit') {
        dispatch(updateConfig({ configId }));
        dispatch(setMode(SERVICE_INTEGRATION_MODE_FORM));
      } else {
        dispatch(
          updateTableAction({
            selectedConfig: configId,
            actionType: configStateCode[selectedMenuItem],
          }),
        );
        dispatch(setWarningModalVisibility(true));
      }
    } else {
      dispatch(setEnablePartnerModalVisibility(true));
    }
  };

  const itemList = getItems(rowData.state);

  return (
    <Dropdown menu={{ items: itemList, onClick: onApply }}>
      <Space>
        <MoreOutlined />
      </Space>
    </Dropdown>
  );
}

export default KebabColumn;
